module.exports = __webpack_public_path__ + "static/media/video-fr.6910133a.png";